import React from 'react';
import Favicon from 'react-favicon';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import RestaurantIndexPage from '../components/pages/RestaurantIndexPage';
import HistoryPage from '../components/pages/HistoryPage';
import AccountPage from '../components/pages/AccountPage';
import CartPage from '../components/pages/CartPage';
import TermsConditionsPage from '../components/pages/TermsConditionsPage';
import OrderStatusPage from '../components/pages/OrderStatusPage';
import ForgotPasswordPage from '../components/pages/ForgotPasswordPage';
import NotFoundPage from '../components/NotFoundPage';

const MainRouter = (props) => {
    return (
        <BrowserRouter>
            <div>
                <Favicon url="/favicon.ico" />
                <Switch>
                    <Route path="/:sitename/:lid/order/" component={RestaurantIndexPage} exact={true} />
                    <Route path="/:sitename/:lid/cart/" component={CartPage} exact={true} />
                    <Route path="/:sitename/:lid/history/" component={HistoryPage} exact={true} />
                    <Route path="/:sitename/:lid/account/" component={AccountPage} exact={true} />
                    <Route path="/:sitename/:lid/support/" component={AccountPage} exact={true} />
                    <Route path="/:sitename/:lid/status/" component={OrderStatusPage} exact={true} />
                    <Route path="/:sitename/:lid/termsconditions/" component={TermsConditionsPage} exact={true} />
                    <Route path="/:sitename/:lid/forgotpassword/" component={ForgotPasswordPage} exact={true} />

                    <Route component={NotFoundPage} />
                </Switch>
            </div>
        </BrowserRouter>
    );
}

export default MainRouter;